'use client';

import { AuthProvider } from '@/hooks/useAuth';
import { WebSocketProvider } from '@/contexts/WebSocketContext';
import { LanguageProvider } from './LanguageProvider';
import { Toaster } from 'react-hot-toast';
import { NotificationListener } from '../Notifications';

export function Providers({ children }: { children: React.ReactNode }) {
  return (
    <AuthProvider>
      <LanguageProvider>
        <WebSocketProvider>
          {children}
          <NotificationListener />
          <Toaster
            toastOptions={{
              style: {
                background: 'var(--bg-surface-solid)',
                color: 'var(--text-primary)',
                border: '1px solid var(--border-subtle)',
                borderRadius: 'var(--radius-lg)',
                boxShadow: 'var(--shadow-popover)',
                fontFamily: 'var(--font-system)',
              },
            }}
          />
        </WebSocketProvider>
      </LanguageProvider>
    </AuthProvider>
  );
}
